import React from 'react';

// Shimmer placeholder block (matches the existing animate-pulse pattern).
function Skeleton({ className = 'h-24' }) {
  return <div className={`animate-pulse rounded-2xl bg-gray-200 ${className}`} />;
}

export default Skeleton;
